var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#2A65E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.18961 7.79971C9.15949 7.77215 9.13413 7.74796 9.10765 7.72484C8.11685 6.85936 7.12633 5.99365 6.13431 5.12916C6.04292 5.04955 5.98449 4.96227 6.00397 4.84689C6.04049 4.63037 6.33097 4.52695 6.5322 4.6586C6.56251 4.67846 6.58889 4.70309 6.61589 4.72662C7.6928 5.66681 8.76968 6.60712 9.84636 7.54751C10.0516 7.72675 10.0512 7.87374 9.84524 8.05372C8.76599 8.99627 7.68622 9.93837 6.60795 10.8818C6.50194 10.9745 6.38626 11.0268 6.23504 10.986C6.01074 10.9255 5.92696 10.6905 6.0722 10.5298C6.09574 10.5038 6.12427 10.4812 6.15122 10.4576C7.13711 9.5964 8.1232 8.73533 9.10905 7.8741C9.13548 7.85102 9.16051 7.82671 9.18961 7.79971Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft02);
export default __webpack_public_path__ + "static/media/arrow-left-02.cf70495a12cc49c8cfb0b65b11a38a93.svg";
export { ForwardRef as ReactComponent };